import React from 'react';
import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import { StyledButtonWrapper } from './styles';

const DS_GoogleMapButton = ({ locationName, label, fixWidth = false, openGoogleMapsTranslation }) => {
  if (!locationName) return;

  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationName)}`;

  return (
    <StyledButtonWrapper className={fixWidth && 'fix-width'}>
      <DS_ButtonLink
        title={label || openGoogleMapsTranslation}
        url={googleMapsUrl}
        buttonVariant="outlined"
        target="_blank"
        noFollow={true}
      />
    </StyledButtonWrapper>
  );
};

export default DS_GoogleMapButton;
